import type { Issue } from "contracts/api/issue/responses";
import { ISSUE_STATUS } from "contracts/enums/core";

const STATUSES: Array<[Issue["status"], string]> = [
  [ISSUE_STATUS.OPEN, "Open"],
  [ISSUE_STATUS.IN_PROGRESS, "In progress"],
  [ISSUE_STATUS.DONE, "Mark done"],
  [ISSUE_STATUS.IGNORED, "Ignore"],
];

export function StatusActions(props: {
  issue: Issue;
  apply: (status: Issue["status"]) => void;
}) {
  return (
    <div class="drawer-actions">
      <span class="drawer-actions-cap">Status</span>
      <div class="status-group">
        {STATUSES.map(([status, label]) => {
          const current = props.issue.status === status;
          return (
            <button
              class={`status-action st-${status} ${current ? "is-current" : ""}`}
              type="button"
              onClick={() => {
                if (!current) {
                  props.apply(status);
                }
              }}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
